export const isValidEmail = (emailToValidate) => {
    if (!emailToValidate) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(emailToValidate);
}